import { hoofdcodesReducer, HoofdcodesState } from "./reducers/hoofdcodes";
import { werkcatReducer, WerkcatsState } from "./reducers/werkcats";
import { configureStore, ConfigureStoreOptions } from "@reduxjs/toolkit";
import { ovksReducer, OvksState } from "./reducers/ovks";
import { bestekFilterReducer, BestekFilterState } from "./reducers/bestek_filter";
import { hoofdcodeFilterReducer, HoofdcodeFilterState } from "./reducers/hoofdcode_filter";
import { subwerkcatReducer, SubwerkcatsState } from "./reducers/subwerkcats";
import { authReducer, AuthState } from "./reducers/auth";
import { loadingReducer, LoadingState } from "./reducers/loading";
import { Message, messageReducer } from "./reducers/messages";
import { bepalingFilterReducer, BepalingFilterState } from "./reducers/bepaling_filter"; // ← NIEUW

export type RootState = {
    werkcats: WerkcatsState;
    subwerkcats: SubwerkcatsState;
    hoofdcodes: HoofdcodesState;
    ovks: OvksState;
    bestek_filter: BestekFilterState;
    hoofdcode_filter: HoofdcodeFilterState;
    auth: AuthState;
    loading: LoadingState;
    messages: {messages: Message[]};
    bepaling_filter: BepalingFilterState; // ← NIEUW
}

const storeOptions: ConfigureStoreOptions = {
    reducer: {
        werkcats: werkcatReducer,
        subwerkcats: subwerkcatReducer,
        hoofdcodes: hoofdcodesReducer,
        ovks: ovksReducer,
        bestek_filter: bestekFilterReducer,
        hoofdcode_filter: hoofdcodeFilterReducer,
        auth: authReducer,
        loading: loadingReducer,
        messages: messageReducer,
        bepaling_filter: bepalingFilterReducer 
    }
}

export const store = configureStore(storeOptions);